<template>
  <div style="max-width: 900px">
    <h2 class="is-size-5" style="margin-bottom: 0.5em">
      <span class="has-text-weight-bold" v-html="$gettext('start.help.heading')"></span>
    </h2>
    <div>
      <div style="margin-bottom: 20px">
        <div>
          <span v-html="$gettext('start.help')"></span>
        </div>
      </div>
    </div>

    <div class="buttons is-centered" style="margin: 0px 0 30px 40px">
      <a 
        class="control button is-link is-outlined" 
        :href="wikiLink('start', 'das_allerwichtigste_in_kuerze')"
        target="_blank"
      >
        <translate>start.help.intro</translate>
        <b-icon icon="external-link" size="is-small"/>
      </a>
      <a 
        class="control button is-link" 
        :href="wikiLink('haeufige_fragen')"
        target="_blank"
      >
        <translate>start.help.faq</translate>
        <b-icon icon="external-link" size="is-small"/>
      </a>
    </div>
    <div style="margin-bottom: 20px;">
      <translate>start.video.tutorials.text</translate>
    </div>
    <div class="buttons is-centered" style="margin: 0px 0 30px 40px">
      <a class="control button is-link is-outlined" href="https://schulung.uni-leipzig.de/leuris-schulung" target="_blank" >
        <translate>start.video.tutorials.link</translate>
        <b-icon icon="external-link" size="is-small"/>
      </a>
    </div>
  </div>
</template>

<script>
import DynamicTitle from '@/components/mixins/DynamicTitle'
import ExternalLinkProvider from '@/components/mixins/ExternalLinkProvider'

export default {
  name: 'help',
  mixins: [DynamicTitle, ExternalLinkProvider],
  data () {
    return {
      msg: 'UL Forschungsbericht',
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.help'
      }
    }
  },
  computed: {
    renderedRouterLinkListActivities () {
      const route = this.$router.resolve({ name: 'auflisten' }, this.$route)
      const linkText = this.$gettext('menu.list')
      return `<a href="${route.href}">${linkText}</a>`
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Help.vue